export const UPDATE_PARKING_EVENTS = 'UPDATE_PARKING_EVENTS';

export function parkingEventsReducer(state = {}, action) {
    switch (action.type) {
        case UPDATE_PARKING_EVENTS:
            return action.payload;
        default:
            return state;
    }
}
